import { apiFetch } from "./client";
import type { components } from "./schema";

export type ClaimOut = components["schemas"]["ClaimOut"];
export type ClaimClose = components["schemas"]["ClaimClose"];
export type MyClaim = components["schemas"]["MyClaim"];
export type MyClaims = components["schemas"]["MyClaims"];

const id = (value: string) => encodeURIComponent(value);

export function myClaims(): Promise<MyClaims> {
  return apiFetch<MyClaims>("/me/claims");
}

export function claimCompany(companyId: string): Promise<ClaimOut> {
  return apiFetch<ClaimOut>(`/companies/${id(companyId)}/claim`, { method: "POST" });
}

/** "Ongedaan maken" within 10 minutes of claiming. */
export function undoClaim(claimId: string): Promise<void> {
  return apiFetch<undefined>(`/claims/${id(claimId)}`, { method: "DELETE" });
}

export function extendClaim(claimId: string): Promise<ClaimOut> {
  return apiFetch<ClaimOut>(`/claims/${id(claimId)}/extend`, { method: "POST" });
}

export function closeClaim(claimId: string, body: ClaimClose): Promise<ClaimOut> {
  return apiFetch<ClaimOut>(`/claims/${id(claimId)}/close`, { method: "POST", json: body });
}

export function setWaitlist(companyId: string, join: boolean): Promise<unknown> {
  return apiFetch<unknown>(`/companies/${id(companyId)}/waitlist`, { method: join ? "PUT" : "DELETE" });
}

export function setReminder(companyId: string, on: boolean): Promise<unknown> {
  return apiFetch<unknown>(`/companies/${id(companyId)}/reminder`, { method: on ? "PUT" : "DELETE" });
}
